module.exports = __webpack_public_path__ + "static/globoplay-448a234d3f0dcfa697ac53c6f8d5ec13.png";